module.exports = __webpack_public_path__ + "static/media/antimage.980d6189.png";